import {makeStyles} from "@material-ui/core/styles";

export default makeStyles(theme => {
    return {
        buttons: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: theme.spacing(1)
        },
        content: {
            paddingTop: theme.spacing(8)
        }
    }
})